import React, { useEffect, useState } from "react";
import { showError, showMessage } from "../ui/Message";
import { pubCall } from "../utils/PubSub";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import Nav from "../ui/Nav";
import { listen } from "../hooks/Listener";
import { SortIcon } from "../utils/Icons";
import { requestPrompt } from "../utils/Utils";

export default function GlobalClassFile(props) {

    const { controller = "", route = "", callback = () => { }, category_1 = "", category_2 = "" } = props;
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({ sort: "category", limit: 45, dynamic: true, search_term : category_1 });
    const [align, setAlign] = useState("auto");
    const [selected, setSelected] = useState({});
    const [loading, setLoading] = useState(false);
    const [init, setInit] = useState(true);
    const buffer = 10;



    const drawSearch = () => {
        requestPrompt({
            route: route, title: "Search", inputProps: { style: { "textAlign": "left" } }, callback: (_s) => {
                setFilters({ ...filters, "search_term": _s })
            }
        })
    }


    const nav = [
        { key: KBD.ESCAPE, action: () => { callback() } },
        { key: KBD.ENTER, action: (e) => { callback(selected) } },
        { text: "Bisac" },
        { text: "Del" },
        { text: "New" },
        { text: "Edt" },
        { text: "Indx", key: KBD.I, action: () => { if (filters.sort === "category") { setAlign("start"); setFilters({ ...filters, "sort": "section", "dynamic": true }) } else { setAlign("start"); setFilters({ ...filters, "sort": "category", "dynamic": true }) } } },
        { text: "Prnt" },
        { key: KBD.S, text: "Srch", action: () => { drawSearch() } },
        { text: "Upd" },
        { text: "Xtra" },
    ]





    //    const showGoto = () => {
    //       requestPrompt({route : route, width : 0, title : "Go to Record #", inputProps : {number : true, style : {"textAlign" : "left"}, width : 100}, width : 50, callback : (e) => {
    //         if(e){
    //             setGoto(e)
    //         }
    //       }})
    //     }



    const colSort = (_text, _key, _current, _callback = () => { }) => {
        const match = (_current === _key);
        if (!match) {
            return (<div onClick={() => _callback(_key)} className="ui-col-sort">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        } else {
            return (<div onClick={() => _callback(_key)} className="ui-col-sort active">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        }
    }


    const columns = [
        {
            key: "class", align: "left", title: colSort("Classification", "category", filters.sort, (_key) => setFilters({ ...filters, "sort": _key, "dynamic": true })), width: 200, render: (e, f) => {
                return <>{f.category_1} - {f.category_2}</>
            }
        },
        { key: "section", title: colSort("SE", "section", filters.sort, (_key) => setFilters({ ...filters, "sort": _key, dynamic: true })), width: 50 },
        { key: "tax_code", title: <>TX</>, width: 45 },
        { key: "discount", title: <>%%</>, width: 45 },
        { key: "frequent_buyer_points", title: <>Pnts</>, width: 60 },
        { key: "receive_account", title: <>Rcv</>, width: 45 },
        { key: "sell_acount", title: <>Sls</>, width: 45 },
        { key: "profit_margin", title: <>PM%</>, width: 45 },
        { key: "description", align: "left", title: <>Description</>, grow: true, width: 298 },
        { key: "sequence", title: <>Seq</>, width: 45 },

    ]






    const fetchInitial = () => {
        if (loading) { return }
        setLoading(true);

        let _filters = { ...filters };
        let _api = "category.getInitial";
        if (filters?.search_term) {
           _filters.search_term = filters?.search_term;
            _api = "category.search";
        }

        pubCall(_api, _filters, (_s, _r) => {
            if (_s) {
                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
                setLoading(false);
                if(_api === "category.search"){
                    setFilters({...filters, "search_term" : ""})
                }
            }
            setInit(false);
            setLoading(false)
        });
    }


    const fetchLast = () => {
        if (loading) { return }
        setLoading(true);

        alert(JSON.stringify(filters, null, 2))

        let _filters = { ...filters };
        let _api = "category.getLast";
        if (category_1 && init) {
            _filters.search_term = category_1;
            _api = "category.search";
        }

        pubCall(_api, _filters, (_s, _r) => {
            if (_s) {
                if (_r.length > 0) {
                    setAlign("auto");
                }
                setData(_r);
                setSelected((_r.length > 0) ? _r[_r.length - 1] : {})
            } else {
                showError(_r);
            }
            setInit(false);
            setLoading(false)
        });
    }


    useEffect(fetchInitial, [filters])

    useEffect(() => {
        const cleanup = listen(controller, route, nav);
        return cleanup;
    }, [nav])



    const next = (_rows = 1) => {

        if (data.length === 0) { setSelected({}); return; }

        setAlign("auto")
        const nextIndex = data.findIndex(item => item?.category_id === selected?.category_id) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        setAlign("auto")
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.category_id === selected?.category_id) - _rows;


        if (prevIndex < 2) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("category.getNext", { ...filters, "limit": 20, "category_id": data[data.length - 1]?.category_id }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("category.getPrevious", { ...filters, "limit": 20, "category_id": data[0]?.category_id }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    return (
        <>
            <div className="shim" /><div className="shim" />
            <VirtualTable
                controller={controller}
                onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                onRowDoubleClick={() => callback(selected)}
                next={next}
                prev={prev}
                getStart={() => fetchInitial()}
                getEnd={() => fetchLast()}
                scrollbar={true}
                scrollindicator={true}
                infinite={true}
                onLoadMore={(_start, _end, _prepend) => {
                    if (_prepend) {
                        if (data?.length > 0 && data[0]?.number !== 1) {
                            fetchPrev()
                        }
                    } else {
                        if (data?.length > 0) {
                            fetchNext();
                        }

                    }
                }}
                align={align}
                row_key={"category_id"}
                current={selected}
                data={data}
                columns={columns}
                width={918}
                loading={loading}
                offset={458}
                route={route}
            />
            <div className="shim" style={{ "height": "4px" }} />
            <div style={{ "marginBottom": "-8px" }}><Nav nav={nav} /></div>
        </>
    )


}
